export default __webpack_public_path__ + "static/media/thecatalogue.1a0c5c70.png";